export const userToken = getGoogleAnalyticsUserIdFromBrowserCookie('_ga');
import { insightsClient } from '@algolia/client-insights';

const client = insightsClient(
  import.meta.env.VITE_ALGOLIA_APP_ID,
  import.meta.env.VITE_ALGOLIA_SEARCH_KEY,
);

const index = import.meta.env.VITE_ALGOLIA_INDEX_NAME;
type conversionEventName = 'Dates & Prices Clicked' | 'Trip Favorited';

const algoliaPayload = (objectID: string) => {
  const queryID = new URLSearchParams(window.location.search).get('queryId');
  const userTokenParam = userToken ? { userToken } : { userToken: 'no-user-token' };
  const queryIDParam = queryID ? { queryID } : {};
  return {
    index,
    objectIDs: [objectID],
    ...queryIDParam,
    ...userTokenParam,
  };
};

export const algoliaConversion = (objectID: string, eventName: conversionEventName) => {
  client.pushEvents({
    events: [
      {
        eventType: 'conversion',
        eventName,
        ...algoliaPayload(objectID),
      },
    ],
  });
};
export const clickedObjectIDs = (objectID: string) => {
  client.pushEvents({
    events: [
      {
        eventType: 'click',
        eventName: 'Trip Clicked',
        ...algoliaPayload(objectID),
      },
    ],
  });
};

function extractGoogleAnalyticsUserIdFromCookie(gaCookie: string) {
  if (!gaCookie) {
    return undefined;
  }

  const userIdParts = gaCookie.split('.').slice(-2);
  return userIdParts.length === 2 ? userIdParts.join('_') : undefined;
}

function getBrowserCookie(cookieName: string) {
  if (typeof document !== 'object' || typeof document.cookie !== 'string') {
    return undefined;
  }

  const name = cookieName + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(';');

  const cookie = cookies.find((c) => c.trim().startsWith(name));
  return cookie ? cookie.trim().substring(name.length) : undefined;
}

function getGoogleAnalyticsUserIdFromBrowserCookie(cookieName: string) {
  const browserCookie = getBrowserCookie(cookieName);
  return browserCookie
    ? extractGoogleAnalyticsUserIdFromCookie(browserCookie)
    : undefined;
}
